//@ts-check

class HelperDatePickerRange {
    minDate = new Date(1900, 0, 1);
    maxDate = new Date(2100, 11, 31);

    /**
     * @param {Date} filterAliasFrom
     * @param {Date} filterAliasTo
     * @param {Date} filterAlias
     * @param {(arg0: Date) => Date | null} funcGetSelectedDate
     */
    GetMinDate(filterAliasFrom, filterAliasTo, filterAlias, funcGetSelectedDate) {
        let existedDateFrom = funcGetSelectedDate(filterAliasFrom);
        return (
            (filterAlias == filterAliasTo && existedDateFrom != null)
                ? existedDateFrom
                : this.minDate
        );
    }
    /**
     * @param {Date} filterAliasFrom
     * @param {Date} filterAliasTo
     * @param {Date} filterAlias
     * @param {(arg0: Date) => Date | null} funcGetSelectedDate
     */
    GetMaxDate(filterAliasFrom, filterAliasTo, filterAlias, funcGetSelectedDate) {
        let existedDateTo = funcGetSelectedDate(filterAliasTo);
        return (
            (filterAlias == filterAliasFrom && existedDateTo != null)
                ? existedDateTo
                : this.maxDate
        );
    }

    GetMinDateFrom() {
        return this.minDate;
    }
    /**
     * @param {Date | null} existedDateFrom
     * @param {Date | undefined} [minDateFrom]
     */
    GetMinDateTo(existedDateFrom, minDateFrom) {
        return (
            (existedDateFrom != null)
                ? existedDateFrom
                : minDateFrom
                    ? minDateFrom
                    : this.minDate
        );
    }
    /**
     * @param {Date | null} existedDateTo
     * @param {Date | undefined} [maxDateTo]
     */
    GetMaxDateFrom(existedDateTo, maxDateTo) {
        return (
            existedDateTo != null
                ? existedDateTo
                : maxDateTo
                    ? maxDateTo
                    : this.maxDate
        );
    }
    GetMaxDateTo() {
        return this.maxDate;
    }

    GetMaxDateToExistedValues() {
        return new Date();
    }
}

export default new HelperDatePickerRange;